import type React from "react"
import { useMemo, useRef, useState } from "react"

import { idsToTableSelectedRowFormat } from "@/components/Tables/Aeros/utils"
import type { Product } from "@/graphql/codegen/graphql"

interface UseProductTableOptionsReturn {
  productsToAssociate: number[]
  selected: Record<string, boolean>
  setSelected: React.Dispatch<React.SetStateAction<Record<string, boolean>>>
  selectedProducts: React.MutableRefObject<Product[]>
}

const useProductTableActionOptions = ({
  associatedProductIds,
}: {
  associatedProductIds: number[]
}): UseProductTableOptionsReturn => {
  // All selected products in the table (newly added and already associated)
  const [selected, setSelected] = useState<Record<string, boolean>>(idsToTableSelectedRowFormat(associatedProductIds))
  const selectedProducts = useRef<Product[]>([])

  // Newly added products (to be submitted)
  const productsToAssociate = useMemo(() => {
    const selectedProductIds = Object.keys(selected).map(Number)
    // Filter out already associated products
    return selectedProductIds.filter((id) => !associatedProductIds.includes(id))
  }, [associatedProductIds, selected])

  return {
    productsToAssociate,
    selected,
    setSelected,
    selectedProducts,
  }
}

export default useProductTableActionOptions
